import apiService from '@common/services/api.service';
import { API } from '@common/services/config';

export default {
    getRates() {
        const url = API.RATES;
        return apiService.lotte.get(url);
    },
};
